import unlockGateway from '@/core/api/gateways/unlockGateway';
import { useFeatureUnlockStore } from '@/core/store/useFeatureUnlockStore';

export function registerFeatureUnlockSyncProvider(pinia) {
  const featureUnlockStore = useFeatureUnlockStore(pinia);
  const provider = unlockGateway.queryScopeUnlockState || unlockGateway.queryImageUnlockState;
  featureUnlockStore.setSyncProvider(provider.bind(unlockGateway));
  return featureUnlockStore;
}

export default registerFeatureUnlockSyncProvider;
